// Configuración de la aplicación
// IMPORTANTE: 
// - En desarrollo local: usa variables de entorno (incluida VITE_API_KEY para App.jsx)
// - En widget publicado (npm/UMD): la API key DEBE ser proporcionada por el usuario como prop
export const config = {
  apiUrl: import.meta.env.VITE_API_URL_PROD,
  appName: import.meta.env.VITE_APP_NAME || 'AMB-IA',
  env: import.meta.env.VITE_ENV || 'production',
  // api_key solo para desarrollo local (App.jsx)
  api_key: import.meta.env.VITE_API_KEY,
}